import { render, staticRenderFns } from "./ShareToFriendsBlock.vue?vue&type=template&id=4024c039&scoped=true&"
import script from "./ShareToFriendsBlock.vue?vue&type=script&lang=js&"
export * from "./ShareToFriendsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ShareToFriendsBlock.vue?vue&type=style&index=0&id=4024c039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4024c039",
  null
  
)

export default component.exports